import styled, { css } from 'styled-components';

import type { IMailSubscriptionTheme } from '@/shared/themes/types';

export const Wrapper = styled.div`
  ${({ theme }: { theme: IMailSubscriptionTheme }) => css`
    width: 100%;
    color: ${theme.defaultDarkColor};
  `}
`;

export const Title = styled.legend`
  ${({ theme }: { theme: IMailSubscriptionTheme }) => css`
    height: 22px;
    margin: 0;
    font-size: ${theme.fontSizes.small};
    font-weight: ${theme.fontWeight.medium};
    color: ${theme.defaultDarkColor};
    border: none;
  `}
`;

export const InputHide = styled.input`
  ${() => css`
    height: 0;
    width: 0;
    position: absolute;
    visibility: hidden;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  `};
`;
export const LabelHide = styled.label`
  ${() => css`
    height: 0;
    width: 0;
    position: absolute;
    visibility: hidden;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  `};
`;
export const FieldsetRadioGroup = styled.fieldset`
  display: block;
`;
export const RadioGroup = styled.div`
  width: inherit;
  display: flex;
  flex-direction: column;
`;

export const RadioInput = styled.input`
  ${({ theme }: { theme: IMailSubscriptionTheme }) => css`
    &:checked {
      color: ${theme.defaultPrimaryColor};
    }
  `}
`;

export const RadioLabel = styled.label`
  ${() => css`
    width: inherit;
    min-height: 22px;
    display: flex;
    margin: 0;

    ${RadioInput} {
      margin: 5px 8px 0 0;
      width: auto;
      height: 13px;
    }
  `}
`;

export const RadioTitle = styled.span`
  ${({ theme }: { theme: IMailSubscriptionTheme }) => css`
    width: inherit;
    font-size: ${theme.fontSizes.medium};
    font-weight: ${theme.fontWeight.medium};
    padding: 2px 0;
  `}
`;
